// Input sanitization utilities to prevent XSS attacks

// Basic HTML entity encoding for text inputs
export const sanitizeText = (input) => {
  if (typeof input !== 'string') return input;
  
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
};

// Sanitize for display in HTML attributes
export const sanitizeAttribute = (input) => {
  if (typeof input !== 'string') return input;
  
  return input
    .replace(/[^\w\s\-_.@]/g, '')
    .trim();
};

// Sanitize email addresses
export const sanitizeEmail = (email) => {
  if (typeof email !== 'string') return email;
  
  return email
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9@._-]/g, '');
};

// Sanitize phone numbers (keep only digits, spaces, hyphens, parentheses, plus)
export const sanitizePhone = (phone) => {
  if (typeof phone !== 'string') return phone;
  
  return phone
    .replace(/[^\d\s\-\(\)\+\.]/g, '')
    .trim();
};

// Sanitize badge numbers (alphanumeric, hyphens, underscores)
export const sanitizeBadgeNumber = (badge) => {
  if (typeof badge !== 'string') return badge;
  
  return badge
    .replace(/[^a-zA-Z0-9\-_]/g, '')
    .trim();
};

// Sanitize text areas (more permissive but still safe)
export const sanitizeTextArea = (input) => {
  if (typeof input !== 'string') return input;
  
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .trim();
};

// General sanitization for form data
export const sanitizeFormData = (formData) => {
  const sanitized = {};
  
  for (const [key, value] of Object.entries(formData)) {
    if (typeof value === 'string') {
      switch (key) {
        case 'email':
        case 'station_email':
          sanitized[key] = sanitizeEmail(value);
          break;
        case 'station_phone':
          sanitized[key] = sanitizePhone(value);
          break;
        case 'badge_number':
          sanitized[key] = sanitizeBadgeNumber(value);
          break;
        case 'station_address':
          sanitized[key] = sanitizeTextArea(value);
          break;
        default:
          sanitized[key] = sanitizeText(value);
      }
    } else {
      sanitized[key] = value;
    }
  }
  
  return sanitized;
}; 